<template src="./template.html"></template>
<style lang="scss" src="./styles.scss" scoped></style>

<script setup>
const props = defineProps({
  modelValue: {
    required: true,
  },
  options: {
    type: Array,
    required: true,
  },
  valueKey: {
    type: String,
    default: "value",
  },
  keyField: {
    type: String,
    default: "id",
  },
  /** Optional class(es) applied to the root wrapper */
  wrapperClass: {
    type: String,
    default: "",
  },
})

function getOptionValue(option) {
  return option?.[props.valueKey]
}

function getOptionKey(option) {
  return option?.[props.keyField] ?? getOptionValue(option)
}

defineEmits(["update:modelValue"])
</script>
